var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #32a1b3;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.01,38.78c-3.2-7.56-7.78-14.35-13.61-20.18-5.83-5.83-12.62-10.41-20.18-13.61C80.39,1.68,72.07,0,63.5,0s-16.89,1.68-24.72,4.99c-7.56,3.2-14.35,7.78-20.18,13.61-5.83,5.83-10.41,12.62-13.61,20.18C1.68,46.61,0,54.93,0,63.5s1.68,16.89,4.99,24.72c3.2,7.56,7.78,14.35,13.61,20.18,5.83,5.83,12.62,10.41,20.18,13.61,7.83,3.31,16.15,4.99,24.72,4.99s16.89-1.68,24.72-4.99c7.56-3.2,14.35-7.78,20.18-13.61,5.83-5.83,10.41-12.62,13.61-20.18,3.31-7.83,4.99-16.15,4.99-24.72s-1.68-16.89-4.99-24.72ZM101.1,101.1c-10.04,10.04-23.4,15.57-37.6,15.57s-27.55-5.53-37.6-15.57c-10.04-10.04-15.57-23.4-15.57-37.6s5.53-27.55,15.57-37.6c10.04-10.04,23.4-15.57,37.6-15.57s27.55,5.53,37.6,15.57c10.04,10.04,15.57,23.4,15.57,37.6s-5.53,27.55-15.57,37.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.47,41.45c-.95-.95-2.22-1.48-3.57-1.48s-2.62.52-3.57,1.47l-33.61,33.61-14.31-14.31c-.95-.96-2.22-1.49-3.57-1.49s-2.62.53-3.57,1.49c-.95.95-1.48,2.22-1.48,3.57s.52,2.61,1.47,3.57l17.89,17.89c.95.95,2.22,1.47,3.57,1.47s2.61-.52,3.57-1.47l37.17-37.17c.96-.96,1.49-2.24,1.49-3.59,0-1.34-.53-2.61-1.48-3.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/Success_Icon.68b236279a5f020372bf789677910969.svg";
export { ForwardRef as ReactComponent };